import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=5aaebbf2"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"
import style0 from "./InputText.vue?vue&type=style&index=0&id=5aaebbf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports